import { apiService } from "./apiService";
import { IProvider } from "../../share/types/provider";

export const ProvidersService = {
  get: (): Promise<IProvider[]> => {
    return apiService.get("/api/providers").then((res) => {
      const { data } = res;
      return res.status === 200 && data.providers ? (data.providers as IProvider[]) : [];
    });
  },
  update: (provider): Promise<any> => {
    return apiService.put("/api/providers", {
      provider
    });
  }
};



// WEBPACK FOOTER //
// ./src/share/services/providers.ts